export const NoMatch = () => {
  return (
    <>
      <p>Page not found.</p>
    </>
  )
}
